import { Link, useMatches } from 'react-router'
import { ChevronRight } from 'lucide-react'

/** 콘텐츠 상단 브레드크럼 — route handle.title 기반, `홈 > {페이지}` */
export function Breadcrumbs() {
  const matches = useMatches()
  const title = (matches.at(-1)?.handle as { title?: string } | undefined)?.title
  const isHome = matches.at(-1)?.pathname === '/v2'

  return (
    <nav aria-label="브레드크럼" className="mb-3 flex items-center gap-1 text-xs">
      {isHome ? (
        <span className="text-[#5f6b7a]">홈</span>
      ) : (
        <>
          <Link to="/v2" className="text-[#0972d3] hover:underline">
            홈
          </Link>
          <ChevronRight className="size-3 text-[#8d99a8]" />
          <span className="text-[#5f6b7a]">{title}</span>
        </>
      )}
    </nav>
  )
}
